import { useAppSelector } from "../../stateManagement/hooks/redux"

export default function RoadWebCameraInfoBlock() {
    const cameraInfo = useAppSelector(state => state.roadWebCamera.cameraInfo)

    return (
        <div className="road-web-camera-info-block">
            <span className="title">Информация о камере</span>
            <div className="content">
                <div>
                    <span className="field">Дорога:</span><span className="value">{cameraInfo?.road}</span>
                </div>
                <div>
                    <span className="field">Направление:</span><span>{cameraInfo?.direction}</span>
                </div>
                <div>
                    <span className="field">Км:</span><span>{cameraInfo?.km?.replace('.',',')}</span>
                </div>
            </div>
        </div>
    )
}
